import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/jenkins-agent/workspace/build-csrb-nma-chat-ui_main/app/components/ClientProvidersWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/jenkins-agent/workspace/build-csrb-nma-chat-ui_main/app/components/ClientScripts.tsx");
;
import(/* webpackMode: "eager" */ "/var/lib/jenkins/jenkins-agent/workspace/build-csrb-nma-chat-ui_main/app/styles/globals.scss");
